import { useSelector } from 'react-redux';
import useGoogleMapsLoader from '../../hook/useGoogleMapsLoader';
import Search from '../DeliveryLocation/Search';
import Modal from '../Modal';
import { isEmptyData } from '../../utils/helper';
import { useEffect, useState } from 'react';
import { GEOLOCATION_PERMISSION } from '../../utils/constants';
import useKeyboard from '../../hook/useKeyboard';
import useCurrentLocation from '../../hook/useCurrentLocation';

const SearchLocation = () => {
  const { isLoading: isLoadingCurrentLocation } = useCurrentLocation();
	const isKeyboardVisible = useKeyboard();
	const { isLoaded: isLoadedGoogleMaps } = useGoogleMapsLoader();
	const user = useSelector((store) => store?.user);
	const gps = useSelector((store) => store?.gps);
	const [isShowSearchLocation, setIsShowSearchLocation] = useState(false);

	const handleOpen = () => {
		setIsShowSearchLocation(true);
	};

	const handleClose = () => {
		setIsShowSearchLocation(false);
	};

	useEffect(() => {
    if (isLoadingCurrentLocation) return;

		if (!isEmptyData(user?.latitude) && !isEmptyData(user?.longitude)) {
			return handleClose();
		}

		const timer = setTimeout(() => {
			if (isEmptyData(user?.latitude) || isEmptyData(user?.longitude)) {
				return handleOpen();
			}
		}, 2500);

		return () => {
			clearTimeout(timer);
		};
	}, [user?.latitude, user?.longitude, isLoadingCurrentLocation]);

	const modalProps = {
		isOpen: isShowSearchLocation,
		position: isKeyboardVisible ? 'top' : 'center',
	};

  const searchProps = {
    onClose: handleClose
  }

	if (!isLoadedGoogleMaps || gps?.permission === GEOLOCATION_PERMISSION.GRANTED) return null;

	return (
		<>
			<Modal {...modalProps}>
				<div className='p-4 overflow-y-scroll'>
					<Search {...searchProps} />
				</div>
			</Modal>
		</>
	);
};

export default SearchLocation;
